// src/utils/testoFormattato.js
// Grassetto e corsivo nelle descrizioni di attività e sottoattività (ottobre 2026).
// Si salva testo semplice con due segni: **grassetto** e _corsivo_ (lo stesso metodo del
// Computo SAL). In app si mostra formattato; in email, PDF e anteprime i segni si tolgono.
// Niente HTML salvato: niente rischi di codice inserito nel testo.
import React from "react";

const RE = /(\*\*[^*\n]+\*\*|_[^_\n]+_)/g;

/** Una riga di testo → elementi React con grassetto e corsivo. */
function riga(t, k) {
  return String(t).split(RE).filter(x => x !== "").map((p, i) => {
    if (/^\*\*[^*\n]+\*\*$/.test(p)) return <strong key={`${k}-${i}`}>{p.slice(2, -2)}</strong>;
    if (/^_[^_\n]+_$/.test(p)) return <em key={`${k}-${i}`}>{p.slice(1, -1)}</em>;
    return <React.Fragment key={`${k}-${i}`}>{p}</React.Fragment>;
  });
}

/** Testo con a capo, grassetto e corsivo. */
export function TestoFormattato({ testo, style }) {
  const righe = String(testo || "").split("\n");
  return (
    <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", ...style }}>
      {righe.map((r, i) => <React.Fragment key={i}>{riga(r, i)}{i < righe.length - 1 ? "\n" : null}</React.Fragment>)}
    </div>
  );
}

/** Il testo senza i segni di formattazione (email, PDF, anteprime su una riga). */
export function testoSemplice(t) {
  return String(t || "").replace(/\*\*([^*\n]+)\*\*/g, "$1").replace(/(^|[^\w])_([^_\n]+)_(?=[^\w]|$)/g, "$1$2");
}

/**
 * Applica (o toglie) il segno al testo selezionato nella casella.
 * Restituisce { valore, inizio, fine } con la nuova selezione.
 */
export function applicaSegno(valore, inizio, fine, segno) {
  const v = String(valore || "");
  let a = inizio, b = fine;
  // senza selezione: la parola sotto il cursore
  if (a === b) {
    while (a > 0 && /\S/.test(v[a - 1])) a--;
    while (b < v.length && /\S/.test(v[b])) b++;
    if (a === b) return { valore: v.slice(0, a) + segno + segno + v.slice(b), inizio: a + segno.length, fine: a + segno.length };
  }
  const sel = v.slice(a, b);
  const n = segno.length;
  // già formattato: si toglie
  if (v.slice(a - n, a) === segno && v.slice(b, b + n) === segno) {
    return { valore: v.slice(0, a - n) + sel + v.slice(b + n), inizio: a - n, fine: b - n };
  }
  if (sel.startsWith(segno) && sel.endsWith(segno) && sel.length >= 2 * n) {
    const dentro = sel.slice(n, -n);
    return { valore: v.slice(0, a) + dentro + v.slice(b), inizio: a, fine: a + dentro.length };
  }
  // gli spazi ai bordi restano fuori dai segni
  const sx = sel.match(/^\s*/)[0].length, dx = sel.match(/\s*$/)[0].length;
  const core = sel.slice(sx, sel.length - dx);
  if (!core) return { valore: v, inizio, fine };
  const nuovo = sel.slice(0, sx) + segno + core + segno + sel.slice(sel.length - dx);
  return { valore: v.slice(0, a) + nuovo + v.slice(b), inizio: a + sx + n, fine: a + sx + n + core.length };
}
